var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-tel-input-vuetify',{attrs:{"value":_vm.value,"rules":_vm.rules,"label":_vm.label,"required":_vm.required,"outlined":_vm.outlined,"solo":"","flat":""},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }